/**
 *  @class
 *  @function BackgroundVideo
 */
if (!customElements.get('recently-viewed-products')) {
    class RecentlyViewedProducts extends HTMLElement {
        constructor() {
            super();
            //Set the number how many products you want to capture
            this.numberOfProduct = 5;
            this.productID = pdpData.productID;
        }

        connectedCallback() {
            this.setRecentlyViewedPdp()
            this.getRecentPdp()
            const title = this.querySelector('h2');
            title.classList.add('test')
        }

        setRecentlyViewedPdp() {
            // Init Empty Array to push data
            const productArr = [];
            // Create a couple of variables
            let jsonResp,
                jsonRespArr,
                jsonRespArrStr;

            productArr.push(pdpData);


            if (localStorage.getItem('recently_viewedPDP') == null) localStorage.setItem('recently_viewedPDP', JSON.stringify([]))

            const oldPdpData = localStorage.getItem('recently_viewedPDP');
            const countPdpData = (oldPdpData.match(/productTitle/g) || []).length;
            const reVisitPdp = oldPdpData.includes(this.productID);
            if (countPdpData < this.numberOfProduct && reVisitPdp === false) {
                jsonResp = JSON.parse(oldPdpData);
                jsonRespArr = jsonResp.concat(productArr);
                jsonRespArrStr = JSON.stringify(jsonRespArr);
                localStorage.setItem('recently_viewedPDP', jsonRespArrStr);
            } else if (countPdpData >= this.numberOfProduct && reVisitPdp === false) {
                jsonResp = JSON.parse(oldPdpData);
                jsonResp.shift();
                jsonRespArr = jsonResp.concat(productArr);
                jsonRespArr = JSON.stringify(jsonRespArr);
                localStorage.setItem('recently_viewedPDP', jsonRespArr);
            }

        }

        getRecentPdp() {
            let pdpData = JSON.parse(localStorage.getItem('recently_viewedPDP'));
            pdpData = pdpData.filter((item)=>item.productID!==this.productID)
            if(pdpData.length===0) this.style.display = 'none';
            pdpData.reverse();
            const recentViewHtml = pdpData.slice(0, 4).map((item)=>{
                return `
                        <li>
                            <a href="${item.productUrl}" title="${item.productTitle}">
                                <div class="cbb-also-bought-product-image" style="background-image: url(${item.productImg});"> </div>
                            </a>
                            <h3 class="cbb-also-bought-product-name">
                            <a href="${item.productUrl}">${item.productTitle}</a></h3>
                            <div class="cbb-also-bought-product-price-container">
                                <span class="cbb-also-bought-product-regular-price">
                                    <span class="money price ${(item.productCompareAtPrice && item.productCompareAtPrice!=='')?"price--sale":''}">
                                    <ins><span class="amount">${item.productPrice}</span></ins>
                                    ${(item.productCompareAtPrice && item.productCompareAtPrice!=='')?`<del><span class="amount">${item.productCompareAtPrice}</span></del>`:''}
                                    </span>
                                    
                                </span>
                            </div>
                        </li>
                    `
            })

            const recentBlock = `${recentViewHtml.join('')}`
            const contentBlock = this.querySelectorAll('.js-recentPdpBlock');
            // Push the data
            contentBlock.forEach(element => {
                element.innerHTML = recentBlock;
            })

        }
    }

    customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
